import { render, staticRenderFns } from "./PayoutsDataTable.vue?vue&type=template&id=5e1282be&scoped=true&"
import script from "./PayoutsDataTable.vue?vue&type=script&lang=js&"
export * from "./PayoutsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./PayoutsDataTable.vue?vue&type=style&index=0&id=5e1282be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1282be",
  null
  
)

export default component.exports